module.exports = __webpack_public_path__ + "assets/img/Type E (82).d2b39f9c.jpg";